// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"03e59fa7","236":"b092b2ee","247":"08160b57","278":"72bbd545","288":"981dc2b6","300":"65aefcde","429":"e01aae8c","551":"3cc08bb8","590":"82b2913f","603":"f2c0ddc8","827":"0d2b5440","901":"da7f0e54","904":"0afaa1ee","971":"3d7b8438"}[chunkId] + ".chunk.js";
};